import React, { useEffect, useState } from "react";
import { fetchPracticeTemplates, getPracticesByNumbers } from "../../api";
import { Row, Col, Container, Table } from "react-bootstrap";
import { jwtDecode } from "jwt-decode";
import ViewTemplate from "./ViewTemplate";

export default function TemplateList({ refresh, onTemplateEdit, viewRefresh }) {
  const [templateList, setTemplateList] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [practiceNames, setPracticeNames] = useState([]);

  useEffect(() => {
    async function fetchTemplates() {
      const token = sessionStorage.getItem("user");
      if (token) {
        const decoded = jwtDecode(token);
        
        // Fetch templates
        const templates = await fetchPracticeTemplates(decoded._id);
        setTemplateList(templates);

        // Fetch practice details
        const practiceData = await getPracticesByNumbers(decoded.practice);
        setPracticeNames(practiceData);
      }
    }
    fetchTemplates();
  }, [refresh]);

  return (
    <div>
      <Row className="g-0">
        <Col md={6}>
          <Container className="border-radius-0 shadow-sm p-3">
            {/* ✅ Initial Assessment Templates */}
            <h6 className="text-primary">Initial Assessment Templates</h6>
            <Table hover responsive className="mt-2">
              <thead>
                <tr>
                  <th className="text-primary fw-normal">Title</th>
                  <th className="text-primary fw-normal">Status</th>
                  <th className="text-primary fw-normal">Practice</th>
                </tr>
              </thead>
              <tbody>
                {templateList.filter((t) => t.templateInitial === "initial").length > 0 ? (
                  templateList
                    .filter((t) => t.templateInitial === "initial")
                    .map((template) => (
                      <tr
                        key={template.id}
                        onClick={() => 
                          setSelectedTemplate({
                            ...template,
                            practiceNames: template.templatePracticeId.map((practiceNumber) => {
                              const practice = practiceNames.find(
                                (p) => p.practiceNumber === practiceNumber
                              );
                              return practice ? practice.practiceName : "Unknown Practice";
                            })
                          })
                        }
                        className="clickable-row"
                      >
                        <td>{template.templateTitle}</td>
                        <td>{template.templateStatus}</td>
                        <td>
                          {template.templatePracticeId.map((practiceNumber) => {
                            const practice = practiceNames.find(
                              (p) => p.practiceNumber === practiceNumber
                            );
                            return (
                              <div key={practiceNumber}>
                                {practice ? practice.practiceName : "Unknown Practice"}
                              </div>
                            );
                          })}
                        </td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-muted text-center">
                      No Initial Assessment Templates Available
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>

            {/* ✅ Follow-up Assessment Templates */}
            <h6 className="text-primary mt-4">Follow-Up Assessment Templates</h6>
            <Table hover responsive className="mt-2">
              <thead>
                <tr>
                  <th className="text-primary fw-normal">Title</th>
                  <th className="text-primary fw-normal">Status</th>
                  <th className="text-primary fw-normal">Practice</th>
                </tr>
              </thead>
              <tbody>
                {templateList.filter((t) =>t.templateInitial === "followup").length > 0 ? (
                  templateList
                    .filter((t) => t.templateInitial === "followup")
                    .map((template) => (
                      <tr
                        key={template.id}
                        onClick={() => 
                          setSelectedTemplate({
                            ...template,
                            practiceNames: template.templatePracticeId.map((practiceNumber) => {
                              const practice = practiceNames.find(
                                (p) => p.practiceNumber === practiceNumber
                              );
                              return practice ? practice.practiceName : "Unknown Practice";
                            })
                          })
                        }
                        className="clickable-row"
                      >
                        <td>{template.templateTitle}</td>
                        <td>{template.templateStatus}</td>
                        <td>
                          {template.templatePracticeId.map((practiceNumber) => {
                            const practice = practiceNames.find(
                              (p) => p.practiceNumber === practiceNumber
                            );
                            return (
                              <div key={practiceNumber}>
                                {practice ? practice.practiceName : "Unknown Practice"}
                              </div>
                            );
                          })}
                        </td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-muted text-center">
                      No Follow-Up Assessment Templates Available
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <h6 className="text-primary mt-4">Patient Report Templates</h6>
            <Table hover responsive className="mt-2">
              <thead>
                <tr>
                  <th className="text-primary fw-normal">Title</th>
                  <th className="text-primary fw-normal">Status</th>
                  <th className="text-primary fw-normal">Practice</th>
                </tr>
              </thead>
              <tbody>
                {templateList.filter((t) => t.templateInitial === "reportexport").length > 0 ? (
                  templateList
                    .filter((t) => t.templateInitial === "reportexport")
                    .map((template) => (
                      <tr
                        key={template.id}
                        onClick={() =>
                          setSelectedTemplate({
                            ...template,
                            practiceNames: template.templatePracticeId.map((practiceNumber) => {
                              const practice = practiceNames.find(
                                (p) => p.practiceNumber === practiceNumber
                              );
                              return practice ? practice.practiceName : "Unknown Practice";
                            })
                          })
                        }
                        className="clickable-row"
                      >
                        <td>{template.templateTitle}</td>
                        <td>{template.templateStatus}</td>
                        <td>
                          {template.templatePracticeId.map((practiceNumber) => {
                            const practice = practiceNames.find(
                              (p) => p.practiceNumber === practiceNumber
                            );
                            return (
                              <div key={practiceNumber}>
                                {practice ? practice.practiceName : "Unknown Practice"}
                              </div>
                            );
                          })}
                        </td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-muted text-center">
                      No Report Templates Available
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>

            <h6 className="text-primary mt-4">Intake Templates</h6>
            <Table hover responsive className="mt-2">
              <thead>
                <tr>
                  <th className="text-primary fw-normal">Title</th>
                  <th className="text-primary fw-normal">Status</th>
                  <th className="text-primary fw-normal">Practice</th>
                </tr>
              </thead>
              <tbody>
                {templateList.filter((t) => t.templateInitial === "intake").length > 0 ? (
                  templateList
                    .filter((t) => t.templateInitial === "intake")
                    .map((template) => (
                      <tr
                        key={template.id}
                        onClick={() =>
                          setSelectedTemplate({
                            ...template,
                            practiceNames: template.templatePracticeId.map((practiceNumber) => {
                              const practice = practiceNames.find(
                                (p) => p.practiceNumber === practiceNumber
                              );
                              return practice ? practice.practiceName : "Unknown Practice";
                            })
                          })
                        }
                        className="clickable-row"
                      >
                        <td>{template.templateTitle}</td>
                        <td>{template.templateStatus}</td>
                        <td>
                          {template.templatePracticeId.map((practiceNumber) => {
                            const practice = practiceNames.find(
                              (p) => p.practiceNumber === practiceNumber
                            );
                            return (
                              <div key={practiceNumber}>
                                {practice ? practice.practiceName : "Unknown Practice"}
                              </div>
                            );
                          })}
                        </td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-muted text-center">
                      No Intake Templates Available
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Container>
        </Col>
        <Col md={6}>
          <Container className="vh-100 border-radius-0 shadow-sm p-3">
            {selectedTemplate ? (
              <ViewTemplate selectedTemplate={selectedTemplate} refresh={refresh} onTemplateEdit={onTemplateEdit}/>
            ) : (
              <p className="text-muted">Select a template to view details.</p>
            )}
          </Container>
        </Col>
      </Row>
    </div>
  );
}
